module.exports = __webpack_public_path__ + "images/bug_orange_large_d4628ff116d9cafe81ed2de5874fd025.png";